<template>
  <div class="freightTable">
    <div class="content" v-if="tableList && tableList.length > 0">
      <div class="table" v-for="(table, index) in tableList" :key="index">
        <div class="table-title">
          <div class="table-title-left">
            <van-image
              class="logoImg"
              width="30"
              height="30"
              :src="imgUrlFilter(table.LogoIcon)"
              v-if="table.LogoIcon"
            ></van-image>
            <van-image width="20" height="20" :src="serviceIcon" v-else></van-image>
            <span v-if="language == 'zh'">{{ table.CargoCategory }}</span>
            <span v-else>{{ table.CargoCategoryEn }}</span>
          </div>
          <div class="table-title-right">
            <span style="font-size: 12px; margin-right: 5px">{{
              $t.calculator.totalFreight
            }}</span>
            <span style="font-size: 16px"
              >{{ table.CurrencySymbol }}{{ table.TotalFreight }}</span
            >
          </div>
        </div>
        <div class="table-subTitle">
          <div class="table-item">
            <span class="table-item-label">{{ $t.calculator.col2 }}</span
            ><span class="table-item-value"
              >{{ table.FirstWeight }}<span v-if="table.WeightUnit == 1">KG</span
              ><span v-if="table.WeightUnit == 2">cbm</span></span
            >
          </div>
          <div class="table-item">
            <span class="table-item-label">{{ $t.calculator.col3 }}</span
            ><span class="table-item-value"
              >{{ table.CurrencySymbol }}{{ table.FirstWeightPrice }}</span
            >
          </div>
          <div class="table-item">
            <span class="table-item-label">{{ $t.calculator.col4 }}</span
            ><span class="table-item-value">
              {{ table.ContinuousWeight }}<span v-if="table.WeightUnit == 1">KG</span
              ><span v-if="table.WeightUnit == 2">cbm</span>
            </span>
          </div>
          <div class="table-item">
            <span class="table-item-label">{{ $t.calculator.col5 }}</span
            ><span class="table-item-value">
              {{ table.CurrencySymbol }}{{ table.ContinuousWeightPrice }}
            </span>
          </div>
          <div class="table-item">
            <span class="table-item-label">{{ $t.calculator.col6 }}</span
            ><span class="table-item-value">
              {{ table.TransportationDuration }}{{ $t.calculator.day }}
            </span>
          </div>
          <div class="table-remark" v-if="table.Remark">
            <van-image width="15" height="15" :src="nailIcon"></van-image
            ><span
              >{{ $t.calculator.remark }}：
              <span v-if="language == 'zh'">{{ table.Remark }}</span>
              <span v-else>{{ table.RemarkEn }}</span>
            </span>
          </div>
        </div>
        <div class="table-buttons">
          <van-button
            block
            size="small"
            type="info"
            class="forecast-btn"
            :icon="sendIcon"
            @click="gotoGoodsForecast(table)"
            >{{ $t.home.shipNow }}</van-button
          >
        </div>
      </div>
    </div>
    <div v-else class="emptyTable">{{ $t.calculator.empty }}</div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Row, Col } from "vant";

Vue.use(Button).use(Row).use(Col);
export default {
  name: "freightTable",
  components: {},
  props: {
    fpid: {
      type: Object,
    },
    tableList: {
      type: Array,
    },
  },
  data() {
    return {
      language: localStorage.getItem("requestLanguage") || "auto",
      sendIcon: require("@/assets/img/freightPriceCalculator/send.png"),
      nailIcon: require("@/assets/img/freightPriceCalculator/nail.png"),
      serviceIcon: require("@/assets/img/freightPriceCalculator/plane.png"),
    };
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    gotoGoodsForecast(item) {
      var fpdid = {};
      fpdid.text = this.language == "zh" ? item.CargoCategory : item.CargoCategoryEn;
      fpdid.value = item.FPDId;
      var data = {
        fpid: this.fpid,
        fpdid: fpdid,
      };
      localStorage.setItem("goodsForecast", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "goodsForecast",
        name: "goodsForecast",
        query: [
          {
            name: "pageType",
            value: "new",
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.freightTable {
  .content {
    ::v-deep .van-collapse-item__content {
      padding: 10px;
    }
    .van-collapse-item {
      ::v-deep .van-icon {
        color: #000;
      }
      ::v-deep .van-cell {
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
      }
    }
    .table {
      margin: 10px;
      padding: 10px 16px;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
      .table-title {
        font-size: 14px;
        .table-title-left {
          width: 65%;
          display: inline-block;
          text-align: left;
          color: #2750aa;
          font-weight: 500;
          vertical-align: middle;
          .logoImg {
            ::v-deep .van-image__img {
              width: 30px;
              height: 30px;
              border-radius: 100px;
              object-fit: cover;
            }
          }
          .van-image {
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
          }
          span {
            display: inline-block;
            vertical-align: middle;
          }
        }
        .table-title-right {
          width: 35%;
          display: inline-block;
          text-align: right;
          color: #ff6827;
          font-weight: bold;
          vertical-align: middle;
          span {
            vertical-align: middle;
            display: inline-block;
          }
        }
      }
      .table-subTitle {
        font-size: 12px;
        color: #999;
        .table-item {
          width: 50%;
          padding-top: 3%;
          display: inline-block;
          .table-item-label {
            display: inline-block;
            width: 70%;
          }
          .table-item-value {
            display: inline-block;
            color: #000;
            font-weight: 500;
          }
        }
        .table-remark {
          margin-top: 3%;
          padding: 8px 16px;
          border-radius: 10px;
          background: #f7f8f9;
          .van-image {
            vertical-align: middle;
            margin-right: 5px;
          }
          span {
            vertical-align: middle;
          }
        }
      }
    }
    .table-row {
      margin-bottom: 10px;
      .van-col {
        text-align: left;
      }
    }
    .table-buttons {
      margin-top: 10px;
      padding-top: 10px;
      border-top: 2px dashed #e4e9f0;
      text-align: center;
      .forecast-btn {
        border: none;
        border-radius: 10px;
        background: #ff6827;
        .van-button__text {
          font-size: 14px !important;
        }
      }
    }
  }
  .emptyTable {
    color: #999;
    font-size: 14px;
    background: #fff;
    text-align: center;
    padding: 20%;
    border: 1px solid #ebedf0;
  }
}
</style>
